import { useQuery } from '@tanstack/react-query';
import { DEFAULT_BEHAVIOR_FLAGS, DEFAULT_SETTINGS, resolveBehaviorFlags, type BehaviorFlagDef, type Clock, type Settings } from '@pirochi/shared';
import { api } from '@/services/api';

interface SettingsPayload {
  settings: Settings;
  flagCatalogue: BehaviorFlagDef[];
  timeZone: string;
}

export function useSettings() {
  const q = useQuery({
    queryKey: ['settings'],
    queryFn: async () => (await api.get<SettingsPayload>('/settings')).data,
    staleTime: 60_000,
  });
  const settings = q.data?.settings ?? DEFAULT_SETTINGS;
  return {
    ...q,
    settings,
    flags: q.data ? resolveBehaviorFlags(q.data.settings.behaviorFlags) : DEFAULT_BEHAVIOR_FLAGS,
    flagCatalogue: q.data?.flagCatalogue ?? [],
    timeZone: q.data?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}

/** Client clock in the business time zone (the original used the browser's local date). */
export function useClock(): () => Clock {
  const { timeZone } = useSettings();
  return () => ({ now: new Date(), timeZone });
}
